import React from 'react';
// import { Link } from 'react-router-dom';
// import Logo from './Logo';
import { Stack } from 'rsuite';
// import img from './erp.png';
import * as images from '../images/charts';
import ArrowLeftLineIcon from '@rsuite/icons/ArrowLeftLine';
import { Icon } from '@rsuite/icons';



const Brand = props => {
  return (
    <Stack className="brand" style={{}} {...props}>
      {/* <Logo height={26} style={{ marginTop: 6 }} /> */}
      <Icon as={ArrowLeftLineIcon} />
        <img style={{'width':'60%', 'height':'20%','marginLeft':'22px'}} src={images.VerCon} />
      
      
    </Stack>
  );
};

export default Brand;
